import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "passwordConfirmation"]

  validate(event) {
    if (this.hasPasswordConfirmationTarget) {
      this.checkPasswordMatch()
    }

    if (!this.element.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    }

    this.element.classList.add("was-validated")
  }

  checkPasswordMatch() {
    const password = this.passwordTarget
    const confirmation = this.passwordConfirmationTarget

    if (password.value !== confirmation.value) {
      confirmation.setCustomValidity("Passwords do not match")
    } else {
      confirmation.setCustomValidity("")
    }
  }
}
